<div class="flex align-items-center justify-content-between">
  <label class="lbl mb-0">Checks</label>
  <button pButton type="button" class="p-button-text p-button-sm" label="Run checks" (click)="mapTools.runChecks()" [disabled]="state.loading" pTooltip="Finds unassigned suburbs surrounded by a region, regions split into pieces, and suburbs in a region of another state"></button>
</div>
<ng-container *ngIf="mapTools.checks as report">
  <div class="meta">{{ report.summary }}</div>
  <button *ngIf="report.fixable && !state.overview && !state.readOnly" pButton type="button" class="p-button-sm p-button-outlined mt-2" label="Fill {{ report.fixable }} unanimous enclave{{ report.fixable === 1 ? '' : 's' }}" (click)="mapTools.fillEnclaves()"></button>
  <ul class="lint">
    <li *ngFor="let row of report.rows" [class]="'lint-' + row.kind" (click)="nav.flyTo(row.code)">
      <span class="kind">{{ row.kind }}</span><span class="body">{{ row.text }}</span>
    </li>
  </ul>
</ng-container>
